import { Navigate, useLocation } from "react-router-dom";
import { getInitialLang } from "@/contexts/LanguageContext";

/**
 * Land page for the raw root `/` (and any path without a `/:lang/` prefix that
 * should belong to public site). Redirects to the detected language:
 * localStorage > navigator.language > DEFAULT_LANG.
 */
const LanguageRedirect = () => {
    const location = useLocation();
    const lang = getInitialLang();
    const suffix = location.pathname === "/" ? "" : location.pathname;
    const target = `/${lang}${suffix}${location.search}${location.hash}`;
    return <Navigate to={target} replace />;
};

export default LanguageRedirect;
